import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root',
})
export class BizzboxService {


  constructor(private http: HttpClient) {}

   getAdreToken() {
    return localStorage.getItem('AndreToken');
  }

  //headers that pass the API Key
  headers = new HttpHeaders({
    x_api_key: environment.XKEY_static_files,
    Authorization: `Bearer ${sessionStorage.getItem('sessionToken')}`,
  });



//funtion to get front card image and video
  async get_bizzboxes(): Promise<any[]> {

      const courses: any = await this.http
      .get<any[]>(`${environment.static_image_url}/api/bizzbox/subscriptions`, {
        headers: this.headers,
      })
      .toPromise();

      return courses
  }




  }









